import React from "react";
import classnames from "classnames";

import { TabContent } from "reactstrap";

export default function DHNTabContent(props) {
  return (
    <TabContent
      {...props}
      className={classnames("dhn-tab-content", props.className)}
    />
  );
}
